<template>
    <div>
        <b-modal
            id="add-risk-level-review-popup"
            ref="modal"
            title="Modify Risk Level Review Cycle"
            size="sm"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            modal-class="hide-footer"
            :hide-header-close="loading"
            @hidden="onHidden"
        >
            <b-form
                class="review-config-form checkbox-invalid"
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form ">
                    <div class="col-md-12">
                        <b-form-group
                            id="low-risk-field"
                            :label="popupLabel"
                            label-for="Low Risk"
                        >
                            <b-form-checkbox-group
                                id="low-risk-checkbox"
                                v-model="selected"
                                v-validate="{
                                    required: true,
                                }"
                                :options="options"
                                name="riskType"
                                :class="{
                                    'is-invalid': errors.has('riskType'),
                                }"
                            ></b-form-checkbox-group>
                        </b-form-group>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :btn-label="buttonLabel"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        :disabled="loading"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        /**
         * Value to determine the current compose mode which
         * varies between 'add' and 'edit'
         */
        title: {
            type: String,
            default: null,
        },
        buttonText: {
            type: String,
            default: 'Update',
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),

            selected: [], // Must be an array reference!
            options: [
                { text: 'Maker', value: 'maker' },
                { text: 'Checker', value: 'checker' },
                { text: 'Approver', value: 'approver' },
            ],
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'hidePopup']),
        titleHeading() {
            return this.selectedItem
                ? 'Modify Risk Level Review Cycle'
                : 'Add Risk Level Review Cycle'
        }, // End of title() method

        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        },
        popupLabel() {
            return (
                this.formData.level +
                ' RISK ' +
                '(' +
                _.startCase(this.formData.alertType) +
                ' ALERT TYPE) '
            )
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            if (value !== null && value !== undefined) {
                Object.assign(this.formData, value)
                this.selected = _.map(this.formData.involvement, function(
                    e,
                    ind
                ) {
                    if (e) {
                        return ind
                    }
                })
                this.selected = _.compact(this.selected)
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                _id: null,
                involvement: {
                    approver: '',
                    checker: '',
                    maker: '',
                },
                level: '',
                alertType: '',
            }
        }, // End of initializeFormData() method
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */
        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    let involvementObj = {}
                    _.map(this.selected, function(e) {
                        Object.assign(involvementObj, { [e]: true })
                    })
                    this.formData.involvement = involvementObj
                    await this.$store.dispatch('onSubmit', this.formData)
                } catch (error) {
                    // console.log(error, 'There is an error on submit')
                }
            }
        }, // End of onSubmit() method
    }, // End of Component > watch
}
</script>
